/**
 * AgentForge agent loop types — product truth for desktop GUI automation.
 *
 * Loop: capture screen → brain plan → parse actions → execute → repeat
 * until done / fail / user stop.
 */

export type AgentActionType =
  | "click"
  | "type"
  | "hotkey"
  | "scroll"
  | "wait"
  | "done"
  | "fail"
  | "note";

export type AgentAction = {
  type: AgentActionType;
  /** Human-readable summary */
  summary: string;
  x?: number;
  y?: number;
  text?: string;
  keys?: string;
  dx?: number;
  dy?: number;
  ms?: number;
};

export type AgentStep = {
  id: string;
  index: number;
  at: string;
  thought?: string;
  action: AgentAction;
  status: "pending" | "running" | "ok" | "error" | "skipped";
  error?: string;
};

export type AgentRunStatus = "idle" | "armed" | "running" | "paused" | "done" | "failed" | "stopped";

export type AgentRun = {
  id: string;
  goal: string;
  status: AgentRunStatus;
  startedAt: string;
  endedAt?: string;
  steps: AgentStep[];
  brainMode: string;
  brainUrl?: string;
  /** Cost estimate when a catalog / Forge-endpoint brain is used */
  estimatedCostUsd?: number;
  notes?: string[];
};

export type AgentPreset = {
  id: string;
  name: string;
  goal: string;
  createdAt: string;
};

/** Suite vision step debit hint (simple meter). */
export const SUITE_STEP_COST_HINT_USD = 0.02;
export const SUITE_MINUTE_COST_HINT_USD = 0.15;
